import { WwWorkType } from '@/configs/enums/commons';

export default [
  {
    path: '/mobile/redirect',
    name: 'mobileRedirect',
    component: () => import('@/views/front/flow/Redirect.vue'),
    meta: { layout: 'mobile', needSetToken: true },
  },
  {
    path: '/mobile/flow-list',
    name: 'flowList',
    component: () => import('@/views/front/flow/main/FlowList.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      redirectType: WwWorkType.工作流消息, // 跳转类型（用于当在企业微信环境下直接访问本页面时，路由自动判断处理成对应的跳转类型）
    },
  },
  {
    path: '/mobile/oper',
    name: 'flowOper',
    component: () => import('@/views/front/flow/start/oper.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      redirectType: WwWorkType.工作流消息, // 跳转类型（用于当在企业微信环境下直接访问本页面时，路由自动判断处理成对应的跳转类型）
    },
  },
  {
    path: '/mobile/my-process',
    name: 'flowMyProcess',
    component: () => import('@/views/front/flow/main/MyProcess.vue'),
    meta: { layout: 'mobile', title: '我发起的', notNeedProgress: true },
  },
  {
    path: '/mobile/flow-detail',
    name: 'flowDetail',
    component: () => import('@/views/front/flow/main/FlowDetail.vue'),
    meta: {
      layout: 'mobile',
      title: '流程详情',
      notNeedProgress: true,
      redirectType: WwWorkType.工作流消息, // 跳转类型（用于当在企业微信环境下直接访问本页面时，路由自动判断处理成对应的跳转类型）
    },
  },
  {
    path: '/mobile/file/review',
    name: 'flowFileReview',
    component: () => import('@/views/front/flow/components/FlowFileReview.vue'),
    meta: { layout: 'mobile', title: '文件预览', notNeedProgress: true },
  },
];
